'use strict';

wbApp.factory('repositorySvc', ['$translate', 'notificationSvc',
    function ($translate, notificationSvc) {

        function entityInserted(collection, entity) {
            if (collection) {
                collection.push(entity);
            }
        }

        function entityRemoved(collection, id, idFieldName) {
            if (!collection) {
                return;
            }

            var idf = idFieldName || 'id';

            for (var i = 0; i < collection.length; i++) {
                if (collection[i][idf] === id) {
                    collection.splice(i, 1);
                    break;
                }
            }
        }

        function entityUpdated(collection, entity, idFieldName) {
            if (!collection) {
                return;
            }

            var idf = idFieldName || 'id';

            for (var i = 0; i < collection.length; i++) {
                if (collection[i][idf] === entity[idf]) {
                    var target = collection[i];

                    angular.copy(entity, target);

                    //for (var k in target) {
                    //    target[k] = entity[k];
                    //}

                    //for (var y in entity) {
                    //    target[y] = entity[y];
                    //}

                    break;
                }
            }
        }

        function get(res, query, successCallback) {
            return customGet('query', res, query, successCallback);
        }

        function customGet(action, res, query, successCallback, errorCallback) {
            return res[action](query, function (successResult) {
                if (!!successCallback) {
                    successCallback(successResult);
                }
            }, function (errorResult) {
                if (!!errorCallback) {
                    errorCallback(errorResult);
                }

                if (errorResult.status === 401) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_UNAUTHORIZED'));
                } else if (errorResult.status === 403) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_TITLE_FORBIDEN'));
                } else {
                    notificationSvc.notifyError(
                        $translate.instant('TXT_ALERT_TITLE_ENTITY_GET_ERROR'),
                        notificationSvc.translateError(errorResult.data));
                }
            });

        }

        function saveAll(res, data, successCallback, errorCallback) {
            return res.saveAll(data, success, error);

            function success(successResult) {
                if (!!successCallback) {
                    successCallback(successResult);
                }
                notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_DATA_SAVED'));
            }

            function error(errorResult) {
                if (errorResult.status === 401) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_UNAUTHORIZED'));
                } else if (errorResult.status === 403) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_TITLE_FORBIDEN'));
                } else {
                    if (!!errorCallback) {
                        errorCallback(errorResult.data);
                    } else {
                        notificationSvc.notifyError(
                            $translate.instant('TXT_ALERT_TITLE_DATA_SAVE_ERROR'),
                            notificationSvc.translateError(errorResult.data));
                    }
                }
            }
        }

        function save(res, collection, data, successCallback, errorCallback, idFieldName) {
            return res.save(data, function (successResult) {
                if (!!successCallback) {
                    successCallback(successResult);
                }

                var idf = idFieldName || 'id';

                if (data[idf] <= 0) { // Created
                    entityInserted(collection, successResult);
                } else { // Updated
                    entityUpdated(collection, successResult, idFieldName);
                }
                notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_ENTITY_SAVED'));
            }, function (errorResult) {
                if (errorResult.status === 401) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_UNAUTHORIZED'));
                } else if (errorResult.status === 403) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_TITLE_FORBIDEN'));
                } else {
                    if (!!errorCallback) {
                        errorCallback(errorResult.data);
                    } else {
                        notificationSvc.notifyError(
                            $translate.instant('TXT_ALERT_TITLE_ENTITY_SAVE_ERROR'),
                            notificationSvc.translateError(errorResult.data));
                    }
                }
            });
        }

        function insert(res, collection, data, successCallback, errorCallback, addToCollection) {
            return res.insert(data, function (successResult) {
                if (!!successCallback) {
                    successCallback(successResult);
                }

                var updateCache = true;
                if (addToCollection && (typeof addToCollection === "function")) {
                    updateCache = addToCollection(successResult);
                }

                if (updateCache) {
                    entityInserted(collection, successResult);
                }

                notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_ENTITY_SAVED'));
            }, function (errorResult) {
                if (errorResult.status === 401) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_UNAUTHORIZED'));
                } else if (errorResult.status === 403) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_TITLE_FORBIDEN'));
                } else {
                    if (!!errorCallback) {
                        errorCallback(errorResult.data);
                    } else {
                        notificationSvc.notifyError(
                            $translate.instant('TXT_ALERT_TITLE_ENTITY_SAVE_ERROR'),
                            notificationSvc.translateError(errorResult.data));
                    }
                }
            });
        }

        function updateNoNotification(res, collection, data, successCallback, errorCallback, idFieldName) {
            return res.update(data, function (successResult) {
                if (!!successCallback) {
                    successCallback(successResult);
                }
                entityUpdated(collection, successResult, idFieldName);               
            }, function (errorResult) {
                if (errorResult.status === 401) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_UNAUTHORIZED'));
                } else if (errorResult.status === 403) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_TITLE_FORBIDEN'));
                } else {
                    if (!!errorCallback) {
                        errorCallback(errorResult.data);
                    } else {
                        notificationSvc.notifyError(
                            $translate.instant('TXT_ALERT_TITLE_ENTITY_SAVE_ERROR'),
                            notificationSvc.translateError(errorResult.data));
                    }
                }
            });
        }

        function update(res, collection, data, successCallback, errorCallback, idFieldName, disableNotification) {
            return res.update(data, function (successResult) {
                if (!!successCallback) {
                    successCallback(successResult);
                }
                entityUpdated(collection, successResult, idFieldName);
                if (!disableNotification) {
                    notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_ENTITY_SAVED'));
                }
            }, function (errorResult) {
                if (errorResult.status === 401) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_UNAUTHORIZED'));
                } else if (errorResult.status === 403) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_TITLE_FORBIDEN'));
                } else {
                    if (!!errorCallback) {
                        errorCallback(errorResult.data);
                    } else {
                        notificationSvc.notifyError(
                            $translate.instant('TXT_ALERT_TITLE_ENTITY_SAVE_ERROR'),
                            notificationSvc.translateError(errorResult.data));
                    }
                }
            });
        }

        function remove(res, collection, data, successCallback, errorCallback, parameters, idFieldName) {

            var id = !!idFieldName ? data[idFieldName] : data.id;

            return res.delete(parameters ? parameters : { id: id },
                function (successResult) {
                    entityRemoved(collection, id, idFieldName);
                    if (!!successCallback) {
                        successCallback(successResult);
                    }
                    notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_ENTITY_REMOVED'));                    
                }, function (errorResult) {
                    // On error
                    if (errorResult.status === 401) {
                        notificationSvc.fatalNotify(
                            $translate.instant('TXT_ALERT_UNAUTHORIZED'));
                    } else if (errorResult.status === 403) {
                        notificationSvc.fatalNotify(
                            $translate.instant('TXT_ALERT_TITLE_FORBIDEN'));
                    } else {
                        if (!!errorCallback) {
                            errorCallback(errorResult);
                        } else {
                            notificationSvc.notifyError(
                                $translate.instant('TXT_ALERT_TITLE_ENTITY_REMOVE_ERROR'),
                                notificationSvc.translateError(errorResult.data));
                        }
                    }
                });
        }

        function defaultErrorHandler(errorResult, errorCallback, error_message_id) {
            if (errorResult.status === 401) {
                notificationSvc.fatalNotify(
                    $translate.instant('TXT_ALERT_UNAUTHORIZED'));
            } else if (errorResult.status === 403) {
                notificationSvc.fatalNotify(
                    $translate.instant('TXT_ALERT_TITLE_FORBIDEN'));
            } else {
                if (!!errorCallback) {
                    errorCallback(errorResult.data);
                } else {
                    notificationSvc.notifyError(
                        $translate.instant(error_message_id || 'TXT_ALERT_TITLE_DATA_SAVE_ERROR'),
                        notificationSvc.translateError(errorResult.data));
                }
            }
        }

        function defaultSuccessSaveHandler(successResult, successCallback) {
            if (!!successCallback) {
                successCallback(successResult);
            }
            notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_ENTITY_SAVED'));
        }

        function defaultSuccessRemoveHandler(successResult, successCallback) {
            if (!!successCallback) {
                successCallback(successResult);
            }
            notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_ENTITY_REMOVED'));
        }

        function customPost(action, res, data, successCallback, errorCallback, doNotShowSuccessNotification) {
            return res[action](data, function (successResult) {
                if (!!successCallback) {
                    successCallback(successResult);
                }
                if (!doNotShowSuccessNotification) {
                    notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_CHANGES_SAVED'));
                }
            }, function (errorResult) {
                if (errorResult.status === 401) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_UNAUTHORIZED'));
                } else if (errorResult.status === 403) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_TITLE_FORBIDEN'));
                } else {
                    if (!!errorCallback) {
                        errorCallback(errorResult.data);
                    } else {
                        notificationSvc.notifyError(
                            $translate.instant('TXT_ALERT_TITLE_CHANGES_SAVE_ERROR'),
                            notificationSvc.translateError(errorResult.data));
                    }
                }
            });
        }

        function customPostWithParams(action, res, parameters, data, successCallback, errorCallback, doNotShowSuccessNotification) {
            return res[action](parameters, data, function (successResult) {
                if (!!successCallback) {
                    successCallback(successResult);
                }
                if (!doNotShowSuccessNotification) {
                    notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_CHANGES_SAVED'));
                }
            }, function (errorResult) {
                if (errorResult.status === 401) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_UNAUTHORIZED'));
                } else if (errorResult.status === 403) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_TITLE_FORBIDEN'));
                } else {
                    if (!!errorCallback) {
                        errorCallback(errorResult.data);
                    } else {
                        notificationSvc.notifyError(
                            $translate.instant('TXT_ALERT_TITLE_CHANGES_SAVE_ERROR'),
                            notificationSvc.translateError(errorResult.data));
                    }
                }
            });
        }

        function customPutWithParams(action, res, parameters, postData, successCallback, errorCallback) {
            return res[action](parameters, postData, function (successResult) {
                if (!!successCallback) {
                    successCallback(successResult);
                }
                notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_CHANGES_SAVED'));
            }, function (errorResult) {
                if (errorResult.status === 401) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_UNAUTHORIZED'));
                } else if (errorResult.status === 403) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_TITLE_FORBIDEN'));
                } else {
                    if (!!errorCallback) {
                        errorCallback(extractErrorData(errorResult));
                    } else {
                        notificationSvc.notifyError(
                            $translate.instant('TXT_ALERT_TITLE_CHANGES_SAVE_ERROR'),
                            notificationSvc.translateError(extractErrorData(errorResult)));
                    }
                }
            });
        }

        function customDelete(action, res, parameters, successCallback, errorCallback) {
            return res[action](parameters, function (successResult) {
                if (!!successCallback) {
                    successCallback(successResult);
                }
                notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_ENTITY_REMOVED'));
            }, function (errorResult) {
                if (errorResult.status === 401) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_UNAUTHORIZED'));
                } else if (errorResult.status === 403) {
                    notificationSvc.fatalNotify(
                        $translate.instant('TXT_ALERT_TITLE_FORBIDEN'));
                } else {
                    if (!!errorCallback) {
                        errorCallback(errorResult.data);
                    } else {
                        notificationSvc.notifyError(
                            $translate.instant('TXT_ALERT_TITLE_ENTITY_REMOVE_ERROR'),
                            notificationSvc.translateError(errorResult.data));
                    }
                }
            });
        }


        function extractErrorData(error) {
            if (!!error && !!error.title) {
                return {
                    message: error.title
                };
            }

            return error.data;
        }

        return {
            save: save,
            saveAll: saveAll,
            insert: insert,
            update: update,
            remove: remove,
            get: get,
            customGet: customGet,
            entityInserted: entityInserted,
            entityRemoved: entityRemoved,
            entityUpdated: entityUpdated,
            defaultErrorHandler: defaultErrorHandler,
            defaultSuccessSaveHandler: defaultSuccessSaveHandler,
            defaultSuccessRemoveHandler: defaultSuccessRemoveHandler,
            customPost: customPost,
            customPostWithParams: customPostWithParams,
            customPutWithParams: customPutWithParams,
            customDelete: customDelete,
            extractErrorData: extractErrorData
        }

    }
]);